import { addEventListenerOnce } from './addListenerOnce';

const TRANSITION_END_EVENTS = {
	transition: 'transitionend',
	OTransition: 'oTransitionEnd',
	MozTransition: 'transitionend',
	WebkitTransition: 'webkitTransitionEnd'
};

const ANIMATION_END_EVENTS = {
	animation: 'animationend',
	OAnimation: 'oAnimationEnd',
	MozAnimation: 'animationend',
	WebkitAnimation: 'webkitAnimationEnd'
};

export const effects = {
	transition: {
		endEvent: null,
		endEventsList: TRANSITION_END_EVENTS
	},
	animation: {
		endEvent: null,
		endEventsList: ANIMATION_END_EVENTS
	}
};

export const whichEffectEndEvent = (type = 'transition') => {
	if (effects[type].endEvent !== null) {
		return effects[type].endEvent;
	}
	const el = document.createElement('fakeelement');
	effects[type].endEvent = Object.keys(effects[type].endEventsList).reduce(
		(a, c) => a || (typeof el.style[c] !== 'undefined' ? effects[type].endEventsList[c] : a),
		false
	);
	return effects[type].endEvent;
};

export const onEffectEndEvent = (element, callback, type = 'transition', delay = 300) => {
	const endEvent = whichEffectEndEvent(type);
	if (endEvent) {
		addEventListenerOnce(element, endEvent, callback);
		return;
	}
	setTimeout(callback, delay);
};
